import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Head from "next/head";
import { useMemo, useEffect } from "react";
const HubspotForm = ({
  region,
  portalId,
  formId,
  sfdcCampaignId
}) => {
  const formWrapperId = useMemo(() => `hubspot-form-${portalId}-${formId}`.replace(/[^a-zA-Z0-9-]/g, "-"), [portalId, formId]);
  useEffect(() => {
    const createForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region,
          portalId,
          formId,
          target: `#${formWrapperId}`,
          sfdcCampaignId
        });
      }
    };
    if (window.hbspt) {
      createForm();
    } else {
      const script = document.getElementById("hs-forms-v2");
      if (script) {
        script.onload = createForm;
      }
    }
  }, [region, portalId, formId, sfdcCampaignId, formWrapperId]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("script", { id: "hs-forms-v2", src: "https://js.hsforms.net/forms/v2.js", async: true }) }),
    /* @__PURE__ */ jsx("div", { id: formWrapperId })
  ] });
};
export {
  HubspotForm as default
};
